const ExcelJS = require("exceljs");
const FileSaver = require("file-saver");

module.exports = {
  handleExporttoExcel: (file, sheet, column, row) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(sheet);
    worksheet.columns = column;
    row.map((x) => {
      worksheet.addRow(x);
    });
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, file + ".xlsx");
    });
  },
};
